// extracted by mini-css-extract-plugin
module.exports = {"releaseProfile":"ReleaseProfile-releaseProfile-1BOdr Card-card-1iGZk","enabled":"ReleaseProfile-enabled-300UC"};